export function getTravelFilePreviewKind(file) {
    var _a;
    if ('preview_type' in file)
        return file.preview_type === 'image' || file.preview_type === 'pdf' ? file.preview_type : null;
    // Older API responses have a storage path even when the display name was changed.
    for (const value of [file.file_url, file.url, file.name, file.file_name]) {
        const filename = String(value || '').split(/[?#]/)[0].split('/').pop() || '';
        if (!filename.includes('.'))
            continue;
        const extension = (_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (extension === 'pdf')
            return 'pdf';
        if (extension && ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp'].includes(extension))
            return 'image';
        return null;
    }
    return null;
}
export function buildTravelFilePreviewUrl(file, webBase, apiBase = webBase) {
    const kind = getTravelFilePreviewKind(file);
    if (!kind || typeof file.download_url !== 'string' || !file.download_url)
        return null;
    try {
        const source = new URL(file.download_url, apiBase);
        const apiOrigin = new URL(apiBase).origin;
        if (source.origin !== apiOrigin || !/^https?:$/.test(source.protocol))
            return null;
        if (!/^\/travel\/api\/download_travel_file\/[0-9a-f-]+\/\d+\/$/i.test(source.pathname))
            return null;
        const viewer = new URL('/file-preview.html', webBase);
        viewer.hash = new URLSearchParams({ file: source.href, kind }).toString();
        return viewer.href;
    }
    catch {
        return null;
    }
}
